export const text = (theme) => ({
    /* Styles applied to the root element. */
    root: {
        margin: 0,
    },
    overline: {
        "&:before": {
            content: '""',
            width: 50,
            display: "block",
            height: 4,
            borderRadius: 2,
            backgroundColor: theme.customPalette.black,
            marginBottom: theme.spacing(3),
        },
    },
    weightBold: theme.text.bold,
    weightMedium: theme.text.medium,
    weightNormal: theme.text.normal,
    /* Styles applied to the root element if `variant="specialTitleXXL"`. */
    specialTitleXXL: {
        ...theme.text.specialTitleXXL,
        color: theme.customPalette.black,
    },
    /* Styles applied to the root element if `variant="specialTitleXL"`. */
    specialTitleXL: {
        ...theme.text.specialTitleXL,
        color: theme.customPalette.black,
    },
    /* Styles applied to the root element if `variant="titleXXXL"`. */
    titleXXXL: {
        ...theme.text.titleXXXL,
        color: theme.customPalette.black,
    },
    /* Styles applied to the root element if `variant="titleXXL"`. */
    titleXXL: {
        ...theme.text.titleXXL,
        color: theme.customPalette.black,
    },
    /* Styles applied to the root element if `variant="titleXL"`. */
    titleXL: theme.text.titleXL,
    /* Styles applied to the root element if `variant="titleL"`. */
    titleL: theme.text.titleL,
    /* Styles applied to the root element if `variant="titleL"`. */
    title: theme.text.title,
    /* Styles applied to the root element if `variant="bodyM"`. */
    bodyM: theme.text.bodyM,
    /* Styles applied to the root element if `variant="bodyS"`. */
    bodyS: theme.text.bodyS,
    /* Styles applied to the root element if `variant="bodyXS"`. */
    bodyXS: theme.text.bodyXS,
    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
        position: "absolute",
        height: 1,
        width: 1,
        overflow: "hidden",
    },
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
        textAlign: "left",
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
        textAlign: "center",
        "&:before": {
            marginLeft: "auto",
            marginRight: "auto",
        },
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
        textAlign: "right",
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
        textAlign: "justify",
    },
    /* Styles applied to the root element if `verticalAlign="middle"`. */
    verticalAlignMiddle: {
        margin: "auto",
    },
    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
        marginBottom: "0.35em",
    },
    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
        marginBottom: 16,
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
        color: "inherit",
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
        color: theme.palette.primary.main,
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
        color: theme.palette.secondary.main,
    },
    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
        color: theme.palette.text.primary,
    },
    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
        color: theme.palette.text.secondary,
    },
    /* Styles applied to the root element if `color="textTertiary"`. */
    colorTextTertiary: {
        color: theme.palette.text.tertiary,
    },
    /* Styles applied to the root element if `color="textLabel"`. */
    colorTextLabel: {
        color: theme.palette.text.label,
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
        color: theme.palette.error.main,
    },
    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
        display: "inline",
    },
    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
        display: "block",
    },
});
